// rootReducer.js
import {combineReducers} from 'redux';
import {uiReducer} from './uiReducer';
import {userReducer} from './userReducer';
import {taxReducer} from './taxReducer';
import {productReducer} from './productReducer';
import {deliveryReducer} from './deliveryReducer';
import {customerReducer} from './customerReducer';
import {documentReducer} from './documentReducer';
import {groupReducer} from './groupReducer';
import {warehouseReducer} from './warehouseReducer';
import {ncfRangeReducer} from "./ncfRangeReducer";
import {paymentMethodReducer} from "./paymentMethodReducer";
import {discountReducer} from "./discountReducer";
import {priceReducer} from "./priceReducer";
import {authReducer} from "./authReducer";
import {measurementUnitReducer} from "./measurementUnitReducer";
import {dgiiCertReducer} from "./dgiiCertReducer";
import {productHandlerReducer} from "./productHandlerReducer";
import { deviceReducer } from './deviceReducer';


export const rootReducer = combineReducers({
    ui: uiReducer,
    auth: authReducer,
    user: userReducer,
    tax: taxReducer,
    product: productReducer,
    delivery: deliveryReducer,
    customer: customerReducer,
    document: documentReducer,
    group: groupReducer,
    warehouse: warehouseReducer,
    ncfRange: ncfRangeReducer,
    paymentMethod: paymentMethodReducer,
    discount: discountReducer,
    price: priceReducer,
    measurementUnit: measurementUnitReducer,
    productHandler: productHandlerReducer, // Assuming productHandler is part of productReducer
    dgiiCert: dgiiCertReducer,
    device : deviceReducer
});